<template>
  <div id="app">
    <!--头部导航-->
    <!-- <banner></banner> -->
    <!-- <router-view></router-view> -->

    <el-button icon="el-icon-caret-top" circle class="goTop" @click="goTop()"></el-button>

    <!-- <div id="monitor1">
      <vue-dplayer :options="options"></vue-dplayer>
    </div> -->

    <!-- <div id="dplayer" class="dplayer video-box"></div> -->

    <!-- 服务协议版 -->
    <!-- <service></service> -->

    <!-- 隐私政策版 -->
    <privacy />
  </div>
</template>
<script>
// import banner from "./components/banner";
import service from "./components/service";
import privacy from "./components/privacy";
import VueDPlayer from "vue-dplayer";
// import DPlayer from "dplayer";
// import $ from "jquery";
export default {
  name: "App",
  components: {
    // banner,
    service,
    privacy,
    VueDPlayer,
  },
  data() {
    return {
      options: {
        autoplay: true, // 开启自动播放
        // preventClickToggle:true,
        volume: 0,
        video: {
          type: "auto",
          url: require("./assets/wxVideo.mp4"),
          // url: 'https://api.dogecloud.com/player/get.mp4?vcode=5ac682e6f8231991&userId=17&ext=.mp4'
        },
      },
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   console.log($("#monitor1"));
    //   $("#monitor1").on("click", this.checkMonitor);
    //   $("#monitor1").on("doubleClick", this.checkMonitor);
    // });
    // const loadVideo = () => {
    //   const dp = new DPlayer({
    //     container: document.getElementById("player"), //播放器容器元素
    //     autoplay: true, //是否自动播放
    //     live: false, //是否直播
    //     theme: "#b7daff", //主题色 底部进度条相关颜色
    //     loop: false, //是否循环播放
    //     lang: "zh-cn", //语言
    //     screenshot: true, //开启截图，如果开启，视频和视频封面需要允许跨域
    //     hotkey: true, //开启热键，支持快进、快退、音量控制、播放暂停
    //     preload: "auto", //视频预加载，可选值: 'none', 'metadata', 'auto'
    //     volume: 0, //初始化音量
    //     playbackSpeed: [0.5, 1, 2, 4, 8], //播放速度
    //     mutex: false, //互斥，阻止多个播放器同时播放，当前播放器播放时暂停其他播放器
    //     preventClickToggle: false, //阻止点击播放器时候自动切换播放/暂停
    //     logo: "logo.png", //在左上角展示一个 logo，你可以通过 CSS 调整它的大小和位置
    //     video: {
    //       pic: "", // 视频封面
    //       url: require("./assets/wxVideo.mp4"),
    //       thumbnails: "", //视频缩略图，可以使用 DPlayer-thumbnails生成
    //       type: "auto", //可选值: 'auto', 'hls', 'flv', 'dash', 'webtorrent', 'normal' 或其他自定义类型,
    //       customType: {
    //         //自定义播放类型文件《type需要设置为'customHls'》
    //         customHls: function (video, player) {
    //           const hls = new Hls();
    //           hls.loadSource(video.src);
    //           hls.attachMedia(video);
    //         },
    //         //自定义播放类型文件《type需要设置为'customFlv'》
    //         customFlv: function (video, player) {
    //           const flvPlayer = Flv.createPlayer({
    //             type: "flv",
    //             url: video.src,
    //           });
    //           flvPlayer.attachMediaElement(video);
    //           flvPlayer.load();
    //         },
    //       },
    //     },
    //   });
    //   //考虑隐私问题，初始化时把音量设为0,才可自动播放
    //   //dp.volume(percentage: number, nostorage: boolean, nonotice: boolean): 设置视频音量
    //   dp.volume(0, true, true);
    //   //视频组件加载完成后自动播放
    //   dp.on("loadedmetadata", function () {
    //     dp.play();
    //   });
    //   //视频流出问题时触发
    //   dp.on("error", function () {
    //     if (document.getElementById("player")) {
    //       //当前时间＋1
    //       let time = Number(Math.round(dp.video.currentTime + 1));
    //       //重新加载视频
    //       loadVideo();
    //       //跳转到更新后的时间
    //       dp.seek(time);
    //     }
    //   });
    // };
  },
  methods: {
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    // handleUserInteraction() {
    //   if (this.options.autoplay) {
    //     this.$refs.dplayer.player.play();
    //   }
    // },
    // checkMonitor(e) {
    //   console.log(e);
    // },
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* background-image: url(./assets/back.png);  app官网版
  background-size: contain;
  background-position: center; 
  height: 3960px; */
}

.goTop {
  position: fixed;
  right: 50px;
  bottom: 50px;
  z-index: 9999;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  color: #409eff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
  cursor: pointer;
  z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/App.vue